import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ReportDashboardPage" */
	'pages/intervention/Report/ReportDashboardPage'));

export default [{ component, exact: true, path: '/reports/:reportId' }];